export const DEFAULT_BEVERAGES = {
  "plainTextResponse": "",
  "optedOutPersonalization": null,
  "beverageAlcoholicDesc": {
    "beer": "",
    "borbn": "",
    "chmpsprk": "",
    "cognbrdy": "",
    "gin": "",
    "nonalbeer": "",
    "nonalmcktl": "",
    "redwne": "",
    "rosewne": "",
    "rum": "",
    "scotch": "",
    "teqla": "",
    "vodka": "",
    "whsky": "",
    "whtwne": ""
  },
  "beverageAlcoholicLov": {
    "beer": false,
    "borbn": false,
    "chmpsprk": false,
    "cognbrdy": false,
    "gin": false,
    "nonalbeer": false,
    "nonalmcktl": false,
    "redwne": false,
    "rosewne": false,
    "rum": false,
    "scotch": false,
    "teqla": false,
    "vodka": false,
    "whsky": false,
    "whtwne": false
  },
  "beverageNonAlcoholicDesc": {
    "cofdecaf": "",
    "coffee": "",
    "cofspclty": "",
    "enrgydrk": "",
    "juice": "",
    "milk": "",
    "nondairymlk": "",
    "smooth": "",
    "sodacola": "",
    "sodadiet": "",
    "sodaggale": "",
    "sodaothr": "",
    "tea": "",
    "teadecaf": "",
    "water": "",
    "waterspec": ""
  },
  "beverageNonAlcoholicLov": {
    "cofdecaf": false,
    "coffee": false,
    "cofspclty": false,
    "enrgydrk": false,
    "juice": false,
    "milk": false,
    "nondairymlk": false,
    "smooth": false,
    "sodacola": false,
    "sodadiet": false,
    "sodaggale": false,
    "sodaothr": false,
    "tea": false,
    "teadecaf": false,
    "water": false,
    "waterspec": false
  },
};